import { PriceCandle, SupportedResolution } from '../types';
import { ResolutionInSeconds } from './constant';
import { BenchmarkHistorySuccessResponse } from './types';

export const toCandle = (
  data: BenchmarkHistorySuccessResponse,
): PriceCandle[] => {
  return data.t.map((timestamp, index) => {
    return {
      time: timestamp * 1000,
      open: data.o[index],
      high: data.h[index],
      low: data.l[index],
      close: data.c[index],
      volume: data.v[index],
    };
  });
};

export const getFromTimestamp = ({
  resolution,
  count,
  before,
}: {
  resolution: SupportedResolution;
  /** timestamp in seconds */
  before: number;
  count: number;
}) => {
  const timeDiff = ResolutionInSeconds[resolution] * count;
  const from = before - timeDiff;

  return {
    from,
    to: before,
  };
};
